// Core packages
import { Injectable } from '@angular/core';

// Third party packages
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

// Custom packages
import { ApiService } from 'src/app/shared/services/api.service';
import { HelperService } from 'src/app/shared/services/helper.service';

@Injectable({
  providedIn: 'root'
})
export class SearchDocsService {

  /**
   * Class constructor
   */
  constructor(
    private apiService: ApiService,
    private helperService: HelperService
  ) { }

  /**
   * Search docs of all condoStructure
   *
   * @since 1.0.0
   *
   * @param
   */
  getSearchDocs(search: string, properties?: any): Observable<any> {
    const params: any = { search };
    if (Array.isArray(properties)) {
      Object.keys(properties).forEach(key => {
        const newParamKey = `properties[${key}]`;
        const newParamValue = properties[key].id;
        params[newParamKey] = newParamValue;
      });
    }
    return this.apiService
      .apiCall("GET", `document-archives/search-docs`, params)
      .pipe(
        catchError(err => {
          this.helperService.handleError(err);
          return throwError(err);
        })
      );
  }

  /**
   * Search docs of all condoStructure
   *
   * @since 1.0.0
   *
   * @param
   */
  getSearchDocsGeneral(search: string, data?: any): Observable<any> {
    const params: any = { search };
    const area = data ? data.area : undefined;
    const properties = data ? data.properties : undefined;
    const company = data ? data.company : undefined;
    const topic = data ? data.topic : undefined;
    const subTopics = data ? data.subTopics : undefined;
    const documents = data ? data.documents : undefined;
    const supplier = data ? data.supplier : undefined;
    const startDate = data ? data.startDate : undefined;
    const endDate = data ? data.endDate : undefined;
    const protocollo = data ? data.protocollo : undefined;
    const keyword = data ? data.keyword : undefined;

    // Single field params
    if (area) {
      params['area'] = area;
    }
    if (topic) {
      params['topic'] = topic;
    }
    if (supplier) {
      params['supplier'] = supplier;
    }
    if (startDate) {
      params['startDate'] = startDate;
    }
    if (endDate) {
      params['endDate'] = endDate;
    }
    if (company) {
      params['company'] = company;
    }
    if (protocollo) {
      params['protocollo'] = protocollo;
    }
    if (keyword) {
      params['keyword'] = keyword;
    }

    // Array params
    if (Array.isArray(properties)) {
      if (properties.length && properties[0] === "all") {
        const newParamKey = `properties[0]`;
        const newParamValue = "all";
        params[newParamKey] = newParamValue;
      } else {
        Object.keys(properties).forEach(key => {
          const newParamKey = `properties[${key}]`;
          const newParamValue = properties[key].id;
          params[newParamKey] = newParamValue;
        });
      }
    }
    if (Array.isArray(subTopics)) {
      Object.keys(subTopics).forEach(key => {
        const newParamKey = `subTopics[${key}]`;
        const newParamValue = subTopics[key].rawTitle;
        params[newParamKey] = newParamValue;
      });
    }
    if (Array.isArray(documents)) {
      Object.keys(documents).forEach(key => {
        const newParamKey = `documents[${key}]`;
        const newParamValue = documents[key];
        params[newParamKey] = newParamValue;
      });
    }
    return this.apiService
      .apiCall("GET", `document-archives/search-docs-general`, params)
      .pipe(
        catchError(err => {
          this.helperService.handleError(err);
          return throwError(err);
        })
      );
  }

  getSearchDocsGeneralV2(data?: any): Observable<any> {
    const params: any = {};
    const area = data ? data.area : undefined;
    const properties = data ? data.properties : undefined;
    const company = data ? data.company : undefined;
    const topic = data ? data.topic : undefined;
    const subTopics = data ? data.subTopics : undefined;
    const documents = data ? data.documents : undefined;
    const supplier = data ? data.supplier : undefined;
    const startDate = data ? data.startDate : undefined;
    const endDate = data ? data.endDate : undefined;
    const protocollo = data ? data.protocollo : undefined;
    const keyword = data ? data.keyword : undefined;
    if (area) {
      params['area'] = area;
    }
    if (topic) {
      params['topic'] = topic;
    }
    if (supplier) {
      params['supplier'] = supplier;
    }
    if (startDate) {
      params['startDate'] = startDate;
    }
    if (endDate) {
      params['endDate'] = endDate;
    }
    if (company) {
      params['company'] = company;
    }
    if (protocollo) {
      params['protocollo'] = protocollo;
    }
    if (keyword) {
      params['keyword'] = keyword;
    }

    if (Array.isArray(subTopics)) {
      Object.keys(subTopics).forEach(key => {
        const newParamKey = `subTopics[${key}]`;
        const newParamValue = subTopics[key];
        params[newParamKey] = newParamValue;
      });
    }
    if (Array.isArray(documents)) {
      Object.keys(documents).forEach(key => {
        const newParamKey = `documents[${key}]`;
        const newParamValue = documents[key];
        params[newParamKey] = newParamValue;
      });
    }
    if (Array.isArray(properties)) {
      Object.keys(properties).forEach(key => {
        const newParamKey = `properties[${key}]`;
        const newParamValue = properties[key];
        params[newParamKey] = newParamValue;
      });
    }
    return this.apiService
      .apiCall("GET", `document-archives/search-docs-general`, params)
      .pipe(
        catchError(err => {
          this.helperService.handleError(err);
          return throwError(err);
        })
      );
  }

  /**
   * Get all properties
   *
   * @since 1.0.0
   *
   * @param
   */
  getSearchDocsProperties(companyId?: string): Observable<any> {
    if (companyId) {
      return this.apiService
        .apiCall("GET", `properties/get-all/${companyId}`)
        .pipe(
          catchError(err => {
            this.helperService.handleError(err);
            return throwError(err);
          })
        );
    }
    return this.apiService
      .apiCall("GET", `properties/get-all`)
      .pipe(
        catchError(err => {
          this.helperService.handleError(err);
          return throwError(err);
        })
      );
  }
}
